const WOMPath = {
    movieList: (type = ':type?'): string => `/${type}`,
    movieDetail: (id = ':id'): string => `/movie/${id}`,
    person: (id = ':id'): string => `/person/${id}`,
};

export default WOMPath;
